
import React from 'react';

// import NonFSIndex from '../../components/NonFSIndex';

export default function LanguageIndex() {
  // return (
  //   <NonFSIndex
  //     data_type="language"
  //   />
  // );
  return <></>
}
